/**
 * This file is responsible for creating the application configuration based on the environment and platform.
 * It imports different configuration files based on the environment and platform, and merges them into a single configuration object.
 */
import BaseConfig from './config.base';
import ProdConfig from './config.prod';
import StageConfig from './config-stage';
import DevConfig from './config.dev';
import MobileConfig from './config-mobile';
import WebConfig from './config-web';
// Set the initial configuration to the production configuration
let ExtraConfig = ProdConfig;

// Get the platform (mobile or web) based on whether it's a React Native app or not
let platform = 'web'; // Default platform is web

// If the environment is development, override the configuration with the development configuration
if (process.env.NODE_ENV === 'development') {
  ExtraConfig = DevConfig;
} else if (process.env.NODE_ENV === 'stage') {
  ExtraConfig = StageConfig;
}

// If the platform is React Native, merge the mobile configuration with the existing configuration
if (navigator.product === 'ReactNative') {
  platform = 'mobile';
  ExtraConfig = { ...ExtraConfig, ...MobileConfig };
} else {
  // If the platform is web, merge the web configuration with the existing configuration
  ExtraConfig = { ...ExtraConfig, ...WebConfig };
}

// Get the app version from the .env file
const appVersion = process.env.ASSETRON_APP_VERSION ?? '1.0.0';

// Merge the base configuration with the extra configuration to create the final configuration object
const Config = {
  ...BaseConfig,
  ...ExtraConfig,
  platform,
  appVersion,
};

export default Config;
